import React from "react";
import paths from "@icarius-router/paths";
import ScreenSelector from "@icarius-common/screenSelector";
import {
  HealthInstitutionIcon,
  RetirementIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const AffiliationInstitutionDefinition = () => {

  const data = [
    {
      name: getLocalizedString("retirementDefinition"),
      icon: <RetirementIcon />,
      path: paths.retirementDefinition,
    },
    {
      name: getLocalizedString("healthDefinition"),
      icon: <HealthInstitutionIcon />,
      path: paths.healthDefinition,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("defineAffiliationInstitutions")}
      data={data}
    />
  );
}

export default AffiliationInstitutionDefinition;